import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { parse } from 'qs'
import Isvg from 'react-inlinesvg'

import MatchingPairsScreenshotContainer from 'containers/creation_tool/matching_pairs/screenshot_container'
import routeActions from 'redux/actions/routeActions'
import CSSModules from 'react-css-modules'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import styles from './screenshot_route.scss'

import MPIcon from 'assets/views/slides/activities/mp-icon.svg'

class MatchingPairsScreenshotRoute extends PureComponent {

	constructor(props) {
		super(props)
		this.state = {
			params: parse(this.props.location.search.substr(1)),
		}
	}

	componentDidMount() {
		this.props.actions.initializeRoute(this.props.match.params.mpUID, this.state.params.jwt)
	}

	render() {
		return (
			<div styleName='wrapper'>
				<MatchingPairsScreenshotContainer />
				{ this.state.params.withCover !== undefined &&
					<div styleName='cover'>
						<div styleName='container'>
							<Isvg src={MPIcon} cacheGetRequests={true} styleName='icon' />
							<p styleName='text'>Matching Pairs</p>
						</div>
					</div>
				}
			</div>
		)
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch(
		{
			initializeRoute: routeActions.initializeMatchingPairsScreenshot,
		},
		dispatch
	)
}

export default connect(null, mapDispatchToProps)(CSSModules(MatchingPairsScreenshotRoute, styles, {allowMultiple: true}))
